import { useId } from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  const id = useId();
  return (
    <label htmlFor={id} className="inline-flex items-center gap-2 cursor-pointer select-none">
      <span className="relative inline-block w-10 h-6">
        <input
          id={id}
          type="checkbox"
          className="sr-only peer"
          checked={checked}
          disabled={disabled ?? false}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span
          className="absolute inset-0 rounded-full transition-colors"
          style={{
            backgroundColor: checked ? 'var(--ac-accent)' : 'var(--ac-border)',
            opacity: disabled ? 0.5 : 1,
          }}
        />
        <span
          className="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform"
          style={{ transform: checked ? 'translateX(16px)' : 'translateX(0)' }}
        />
      </span>
      {label ? <span className="text-[var(--ac-text)]">{label}</span> : null}
    </label>
  );
}
